import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const ShortLinkRedirect = () => {
  const { slug } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    let done = false;
    api.get(`/shortlink/${encodeURIComponent(slug)}`)
      .then((r) => {
        done = true;
        const t = r.data && r.data.found && r.data.target;
        if (t) {
          if (/^https?:\/\//.test(t)) window.location.replace(t);
          else nav(t, { replace: true });
        } else { nav("/", { replace: true }); }
      })
      .catch(() => { done = true; nav("/", { replace: true }); });
    const fallback = setTimeout(() => { if (!done) nav("/", { replace: true }); }, 6000);
    return () => clearTimeout(fallback);
  }, [slug, nav]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center text-center px-4" data-testid="shortlink-redirect">
      <Loader2 className="animate-spin text-[#ff0033] mb-4" size={28} />
      <p className="text-neutral-400 font-mono-lab text-xs uppercase tracking-widest">Weiterleitung …</p>
    </div>
  );
};

export default ShortLinkRedirect;
